export default {
  getItems: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/companies/getters.js